export default __webpack_public_path__ + "static/media/flexible.218bfe43.png";